/**
 * Trạng thái biên lai
 */
export default {
  New: 1, // Biên lai mới
  Replaced: 2, // Biên lai thay thế
  Adjusted: 3, // Biên lai điều chỉnh
  ReplacedBy: 4, // Biên lai bị thay thế
  AdjustedBy: 5, // Biên lai bị điều chỉnh
};

